import { Fragment } from 'react';
import { Link as FluentLink, Subtitle2 } from '@fluentui/react-components';
import { TResolvedItemsMap } from '@modules/items';
import { getItemPathByItemType } from '@modules/documents';
import DetectionsSummaryTable from '../tables/DetectionsSummaryTable';
import { IBaseDetectedElement, TDetectionsRowVariant } from '../../../types/shared.types';

type TProps<TDetectedElement extends IBaseDetectedElement> = {
  groupedEntries: Array<[string, TDetectedElement[]]>; // [sourceId, rows]
  resolvedItems: TResolvedItemsMap;
  variant: TDetectionsRowVariant; // 'references' | 'inline-blocks'
};

const SummarySectionsList = <TDetectedElement extends IBaseDetectedElement>({
  groupedEntries,
  resolvedItems,
  variant,
}: TProps<TDetectedElement>) => {
  return (
    <Fragment>
      {groupedEntries.map(([sourceId, detectedElements]) => {
        const item = resolvedItems[sourceId]?.item;
        const label = item ? item.name : 'Unknown document';
        const href = item ? `/${getItemPathByItemType(item.type)}/${item._id}` : undefined;

        return (
          <div key={sourceId} className="flex flex-col space-y-2">
            <FluentLink appearance="subtle" href={href} target="_blank" onClick={(e) => e.stopPropagation()}>
              <Subtitle2>{label}</Subtitle2>
            </FluentLink>

            <DetectionsSummaryTable
              variant={variant}
              sourceId={sourceId}
              detectedElements={detectedElements}
              resolvedItems={resolvedItems}
            />
          </div>
        );
      })}
    </Fragment>
  );
};

export default SummarySectionsList;
